export const types = {
	1: "close_question",
	2: "open_question"
};


export default {
	types,
	getTypeName(type) {
		return types[type] || {};
	}

};
